import { Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

export const routes: Routes = environment.routes;
